import React, { Component } from 'react';
import { Button, Container, Form, Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { userChangeAction, tabChangeAction } from '../../stores/actions/userData';
import logo from './../../img/logo.svg';
import './loginStyle.scss';
import loginService from './loginService';
import ssoService from './sso/ssoService';
import { authService } from './../../Auth.service';
import { Config } from '../../shared/config';
import { connect } from 'react-redux';

const SSO_APP = 'vista';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            passMinStrength: Config.form.validation.password.minLength,
            email: '',
            password: '',
            errors: {
                message: '',
            },
            validated: null,
        };
        this.loginService = new loginService();
        this.authService = new authService();
        this.ssoService = new ssoService();
        this.login = this.login.bind(this);
        this.emailInputRef = React.createRef();
    }

    /**
     * Ui rendering for class component
     */
    render() {
        //Set state variables for ui rendering
        const { email, validated } = this.state;
        return (
            <div className="dummy">
                <div className="content-box">
                    <Container className="p-4 mt-3">
                        <img className="branding-login" src={logo} alt="Therigy Logo" />
                    </Container>
                    {/* Container for login form */}
                    <Container className="p-4 mt-3 log-box shadow">
                        {/* Form container for login inputs */}

                        <Form validated={validated} onSubmit={this.handleNext} noValidate>
                            <Form.Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            ref={this.emailInputRef}
                                            type="email"
                                            id="email"
                                            name="email"
                                            placeholder="Email"
                                            autoComplete="off"
                                            value={email}
                                            className="email-field"
                                            required
                                            onChange={this.handleChange}
                                            pattern="^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter a valid email address.
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Form.Row>

                            <Row className="mt-3">
                                <Col md={4}>
                                    <Button
                                        type="submit"
                                        className="submit-btn"
                                        variant="primary"
                                        size="lg"
                                        id="next-btn"
                                        block
                                    >
                                        Login
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Container>
                </div>
                {/* Footer informations */}
                <div className="login-footer">
                    <p className="footer-text text-center m-0">
                        For immediate assistance, contact Tech Support by phone at
                    </p>
                    <p className="footer-text text-center">
                        <span>407.992.8750 x3</span> or via email at
                        <span>
                            {' '}
                            <a href="mailto:support@therigy.com">support@therigy.com</a>
                        </span>
                    </p>
                </div>
            </div>
        );
    }

    /**
     * Invoking on component mount
     * Getting login status for redirection
     */
    componentDidMount() {
        // Check already logged in or not
        // this.authService.checkSSOLoginToken();
        this.subscription = this.authService.getLoginStatus().subscribe((status) => {
            if (status) {
                this.props.history.push('/model/list');
            }
        });
        this.emailInputRef.current.focus();
    }

    /**
     * Subscribe on before loading component
     */
    componentWillUnmount() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    /**
     * Input change method for setting email, password to state
     * @param evt event
     */
    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        if (name === 'email') {
            this.setState({ email: value });
        }
        //Set state for validation
        this.setState({ [name]: value, validated: false });
    };

    /**
     * Form Submisstion
     * @param evt event
     */
    handleSubmit = (event) => {
        event.preventDefault();
        const { passMinStrength, errors, email, password } = this.state;
        //Set error message
        errors.message = '';
        this.setState({ errors });
        if (email && password && validEmailRegex.test(email)) {
            // Checking for valid email
            if (password.length >= +passMinStrength) {
                // Checking for password length
                if (validateForm(errors)) {
                    this.login(); // Invoking Login method on successful form validation
                }
            }
        }

        this.setState({ validated: true });
    };

    /**
     * Form Submisstion
     * @param evt event
     */
    handleNext = (event) => {
        event.preventDefault();
        const { errors, email } = this.state;
        //Set error message
        errors.message = '';
        this.setState({ errors });
        if (email && validEmailRegex.test(email)) {
            // Checking for valid email
            this.checkIfSsoEnabled(); // Invoking sso validation
        } else {
            this.setState({ validated: true });
        }
    };

    /**
     * checkIfSsoEnabled if it is enabled redirect to SSO page or else to password page
     */

    checkIfSsoEnabled = () => {
        const { email } = this.state;

        this.ssoService.isSsoEnable({ app: SSO_APP, email: email }).then((res) => {
            if (res && res.status === 200 && res.data) {
                const { ssoLoginUrl } = res.data;
                window.location.replace(ssoLoginUrl);
            }
        });
    };

    /**
     * Login method to be invoked on successful form validation
     */
    login() {
        const { email, password } = this.state;
        const params = { username: email, password: password };
        //login api integration
        this.loginService.checkCredentials(params).then((res) => {
            if (res?.status?.toLowerCase() === 'success') {
                //Success response handliang and redirection
                this.authService.setLoggedin({ userdata: res.data });
                this.subscription = this.authService.getLoginStatus().subscribe((status) => {
                    if (status) {
                        this.props.updateUser({});
                        this.props.setCurrentTab(null);
                        this.props.history.push('/model/list');
                    }
                });
            } else {
                //Error response handliang and show error message
                const errors = { message: '' };
                errors.message = res && res.message ? res.message : 'Something went wrong!';
                this.setState({ errors });
            }
        });
    }
}
/* Email validation regex */
const validEmailRegex = RegExp(
    '^(([^<>()[]\\.,;:s@]+(.[^<>()[]\\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$',
); // eslint-disable-line
/**
 * Form validation to check any errors exists
 * @param errors errors
 */
const validateForm = (errors) => {
    let valid = true;
    valid = Object.keys(errors).map(function (val) {
        if (val.length > 0) {
            return true;
        }
        return false;
    });
    return valid;
};

//Dispatch data to redux store
const MapDispatchToProps = (dispatch) => {
    return {
        updateUser: (params) => dispatch(userChangeAction(params)),
        setCurrentTab: (params) => dispatch(tabChangeAction(params)),
    };
};
//Set login porperties
Login.propTypes = {
    updateUser: PropTypes.func,
    setCurrentTab: PropTypes.func,
    history: PropTypes.object.isRequired,
};

export default connect(null, MapDispatchToProps)(withRouter(Login));
